<template>
  <section class="navbar">
    <div class="navbar__left">
      <a target="_blank" :href="`${button.url}`">
        <img
          class="navbar__left--logo" :src="`${ data.logo}`"
        />
      </a>
    </div>
    <div class="navbar__right">
      <div
        v-if="data.country_toggle.length > 0"
        class="navbar__right--toggle"
        @click="showToggles = !showToggles"
      >
        <img
          :src="`${data.country_toggle[0].logo}`
          "
          :alt="data.country_toggle"
        />
      </div>
      <div
        v-if="showToggles"
        class="navbar__right--list animate__animated animate__bounceInDown"
      >
        <p class="title">{{ data.language }}</p>
        <a
          v-for="(toggle, i) in data.country_toggle"
          :key="`toggle_${i}`"
          :href="toggle.url"
        >
          <img
            :src="`${toggle.logo}`"
            :alt="data.country_toggle"
          />
          <p>{{ toggle.text }}</p>
        </a>
      </div>
    </div>
  </section>
</template>

<script>
import Content from "../data/content";
let lang = process.env.VUE_APP_LOCALITY;

export default {
  name: "Navbar",
  data: function() {
        return {
          data: Content[lang].navbar,
          button: Content[lang].button,
          showToggles: false,
        }
    }
};
</script>

<style lang="scss">
$desktop: 1024px;
$tablet: 768px;
$mobile: 600px;

.navbar {
  margin-bottom: -10px;
  background-color: var(--color-orange-1);
  padding: 20px 5%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 2;
  &__left {
    display: flex;
    align-items: flex-end;
    &:hover {
      transform: scale(1.02);
    }
    @media (max-width: $tablet) {
      flex-direction: column;
      width: 60%;
      align-items: flex-start;
    }
    a {
      max-height: 40px;
    }
    &--logo {
      width: 165px;
      padding: 0 10px 0 0;
      margin: 0;
      cursor: pointer;
      @media (max-width: $tablet) {
        width: 150px;
        padding: 0;
      }
    }
    &--title {
      color: var(--color-white-1);
      font-weight: 600;
      @media (max-width: $tablet) {
        flex-direction: column;
        padding: 10px 0;
      }
    }
  }
  &__right {
    display: flex;
    align-items: self-start;

    &--button {
      padding: 8px;
      background-color: transparent;
      border: 2px solid var(--color-white-1);
      border-radius: 30px;
      cursor: pointer;
      color: var(--color-white-1);
      text-decoration: none;
      display: flex;
      max-width: 200px;
      justify-content: space-evenly;
      align-items: center;
      img {
        margin-right: 2px;
      }
      &:hover {
        transform: scale(1.03);
      }
    }
    &--toggle {
      margin: 0 10px 0 0;
      padding: 0;
      height: 28px;
      widtH: 28px;
      cursor: pointer;
      &:hover {
        transform: scale(1.03);
      }
      img {
        width: 28px;
        border-radius: 50%;
        height: 28px;
        object-fit: cover;
        border: 2px solid var(--color-white-1);
      }
    }
    &--list {
      background-color: var(--color-white-1);
      padding: 10px 24px 5px;
      border-radius: 30px;
      display: flex;
      flex-direction: column;
      position: absolute;
      top: 95px;
      right: 5%;
      min-width: 152px;

      img {
        width: 16px;
        height: 16px;
        border-radius: 50%;
        object-fit: cover;
        margin: 0;
        &:hover {
          transform: scale(1.03);
        }
      }

      a {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin-bottom: 25px;
        text-decoration: none;

        &:hover {
          p {
            color: #ff8000;
          }
        }

        &:first-of-type {
          p {
            font-weight: 600;
          }
        }
      }

      p {
        font-size: 14px;
        margin: 0 0 0 15px;
        color: #293133;
      }

      .title {
        font-size: 18px;
        font-weight: 600;
        margin: 0 0 15px 0;
        padding: 12px 0;
      }
    }
  }
}
</style>